var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbupFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.25H1.75V14H0V5.25ZM8.75 5.25H13.132C13.3747 5.25 13.58 5.334 13.748 5.502C13.916 5.67 14 5.87533 14 6.118V13.132C14 13.3653 13.916 13.566 13.748 13.734C13.58 13.9113 13.3747 14 13.132 14H3.5V5.25L6.132 2.618V1.316C6.132 0.952 6.258 0.644 6.51 0.392C6.77133 0.130667 7.07933 0 7.434 0C7.798 0 8.106 0.130667 8.358 0.392C8.61933 0.644 8.75 0.952 8.75 1.316V5.25Z",
    fill: "content"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbupFill);
export default __webpack_public_path__ + "static/media/thumbup-fill.5c0c02dcd9473f39da158ed087fec7d4.svg";
export { ForwardRef as ReactComponent };